import { createEvent, sample } from 'effector';
import { PostcardActionsEventT, sendPostcardActionsEventFx } from '../lib/effects/sendPostcardActionsEventFx/sendPostcardActionsEventFx';

export const sendSaveEventTrigger = createEvent<PostcardActionsEventT>();

sample({
  clock: sendSaveEventTrigger,
  target: sendPostcardActionsEventFx
});
